/* -------------------------------------------------------------------------- */
/*                          CurrencyDropdownInput                             */
/* -------------------------------------------------------------------------- */
// Este componente utiliza DropdownInput para generar un CurrencyDropdownInput

import * as currencyActions from '@redux/actions/static-catalogs/currencies';
import * as currencySelectors from '@redux/reducers/static-catalogs/currencies';
import { useEffect, useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import DropdownInput from '../DropdownInput';

const CurrencyDropdownInput = (props) => {
  const store = useSelector((state) => state);
  const dispatch = useDispatch();
  const intl = useIntl();
  const currencies = currencySelectors.getCurrenciesList(store);

  //Reset value with initial when values are loaded from db
  const [resetValue, setResetValue] = useState(Date.now());
  const resetDropdown = () => {
    setResetValue(Date.now());
  };

  //Fetch currencies if they have not been fetched yet
  useEffect(() => {
    if (!currencySelectors.haveCurrenciesBeenFetched(store)) {
      dispatch(currencyActions.startFetchingCurrencies());
    }
  }, []);

  //Update reactselect values of  currencies when fetched is finished
  useEffect(() => {
    if (!currencySelectors.isFetchingListCurrencies(store)) {
      resetDropdown();
    }
  }, [currencySelectors.isFetchingListCurrencies(store)]);

  return (
    <DropdownInput
      {...props}
      key={resetValue}
      isLoading={currencySelectors.isFetchingListCurrencies(store)}
      label={<FormattedMessage id="common.currency" />}
      options={currencies.map((curr) => {
        return {
          ...curr,
          id: curr.currencyId,
          value: curr.currencyId,
          //label: curr.currencyName,
          icon: (
            <ReactCountryFlag
              className="country-flag flag-icon"
              countryCode={curr.countryCode}
              style={{
                fontSize: '1.5em',
                lineHeight: '1.5em'
              }}
              svg
            />
          ),
          label: <FormattedMessage id={`currencies.${curr.currencyId}`} />,

          label_intl: intl.formatMessage({ id: 'currencies.' + curr.currencyId })
        };
      })}
    />
  );
};

export default injectIntl(CurrencyDropdownInput);
